export const createReferenceDataRepository = (appFetch) => {
    return {
        office(slug, params = {}) {
            return appFetch.get(`/api/plugin/office/v1/office/${slug}`, {params});
        },
        offices(body, options = {}) {
            return appFetch.post('/api/plugin/office/v1/office/list', body, options);
        },
        atms(body, options = {}) {
            return appFetch.post('/api/plugin/atm/v1/atm/list', body, options);
        },
        terminals(body, options = {}) {
            return appFetch.post('/api/plugin/terminal/v1/terminal/list', body, options);
        },
        regions(options = {}) {
            return appFetch.get('/api/core/v1/reference-data/region/list', options);
        },
    };
};
